module.exports = __webpack_public_path__ + "static/img/f2.a0ef8ce.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/appimg/common/f2.jpg
// module id = sGB0
// module chunks = 11